module.exports = __webpack_public_path__ + "python.svg";